$(() => {
	const cardAccordion = $('.bs-section--about-us-image-accordion, .bs-section--careers-image-accordion');
	if ($(cardAccordion).length > 0) {
		$(cardAccordion).each((index, element) => {
			const contents = $(element).find('.bs-div').clone();
			const desktopContent = $(element).find('.bs-advance-accordion__right-container > div');
			$(desktopContent).prepend(contents);
		});
	}
});